/** @file GIZMO_METRICS: the gizmo's sizes, shared by the drawn meshes and the picking. */

/**
 * The gizmo radius follows the view (`gizmoRadius`): `viewShare` of the viewport's CSS height within `radiusMin`..
 * `radiusMax`, times `toolScale` for move and scale. The handle proportions are drawn at the reference `radius`
 * (CSS px) and scale with the gizmo: the move shaft from `shaftFrom x radius` to the radius, then a cone `coneLength`
 * long and `coneWidth` wide; plane squares `planeSize` wide centred `planeAt x radius` along both axes; the centre
 * square; scale tip and centre cubes. Line widths stay in CSS px at any size: rings `ringWidth` (hover
 * `hoverWidth`), far halves at `farAlpha`, the white silhouette (free rotate) ring on the rings' radius at
 * `outerWidth` and `outerAlpha`. `pickRadius` CSS px; `segments` per full ring.
 */
export const GIZMO_METRICS = {
  viewShare: 0.18, radiusMin: 72, radiusMax: 180, toolScale: 0.75,
  radius: 56, pickRadius: 8, ringWidth: 2, hoverWidth: 3, farAlpha: 0.45, outerWidth: 1.5, outerAlpha: 0.7,
  shaftFrom: 0.2, coneLength: 14, coneWidth: 7, planeSize: 12, planeAt: 0.35, planeAlpha: 0.55, centreSquare: 10,
  cube: 8, centreCube: 10, segments: 64,
} as const;
